<template>
    <div class="container">
        <h1>Termos de Uso — Plataforma Lummefy</h1>
        
        <div class="intro">
            <p>Estes Termos e Condições ("Termos") regulam o uso da plataforma Lummefy e dos serviços oferecidos no site <a href="https://www.lummefy.com.br">www.lummefy.com.br</a>. Ao clicar em "Eu aceito" ou utilizar os serviços, você declara estar de acordo com este documento.</p>
        </div>

        <h2>1. O Site e os Serviços</h2>
        <ul>
            <li>A Lummefy oferece um sistema SaaS para gestão de mentorias.</li>
            <li><strong>Recursos incluem:</strong> formulário de aplicação, agendamento de sessões, gestão de atividades, chat, upload de conteúdos, testes, avaliações e certificados.</li>
            <li>A Lummefy poderá atualizar, modificar ou descontinuar funcionalidades mediante aviso.</li>
        </ul>

        <h2>2. Cadastro</h2>
        <ul>
            <li>O usuário deve fornecer informações verdadeiras no registro.</li>
            <li>A Lummefy pode realizar verificações de segurança e suspender cadastros irregulares.</li>
            <li>O cliente é responsável pela confidencialidade de seu login e senha.</li>
        </ul>

        <h2>3. Obrigações do Usuário</h2>
        <p>O usuário se compromete a:</p>
        <ul>
            <li>Não usar a plataforma para fins ilegais, abusivos ou que violem direitos de terceiros.</li>
            <li>Não enviar conteúdos ofensivos, difamatórios, discriminatórios ou pornográficos.</li>
            <li>Não utilizar a Lummefy para práticas de spam ou fraudes.</li>
            <li>Respeitar a legislação brasileira, incluindo LGPD e direitos autorais.</li>
        </ul>

        <h2>4. Planos e Pagamentos</h2>
        <ul>
            <li>O acesso à plataforma está condicionado ao pagamento do plano contratado.</li>
            <li>Os valores e condições estão descritos no site oficial.</li>
            <li>As taxas não são reembolsáveis, salvo exceções legais.</li>
        </ul>

        <h2>5. Rescisão</h2>
        <ul>
            <li>O usuário pode cancelar sua assinatura a qualquer momento.</li>
            <li>A Lummefy pode encerrar o contrato em caso de violação destes Termos.</li>
            <li>Após o cancelamento, o acesso à plataforma será suspenso.</li>
        </ul>

        <h2>6. Garantias e Limitações</h2>
        <ul>
            <li>A Lummefy prestará os serviços com diligência e segurança razoáveis.</li>
            <li>Não garantimos disponibilidade ininterrupta, pois dependemos de terceiros (ex.: serviços de nuvem).</li>
            <li>A responsabilidade máxima da Lummefy é limitada ao valor pago nos últimos 12 meses.</li>
        </ul>

        <h2>7. Propriedade Intelectual</h2>
        <ul>
            <li>Todo o software, marca e conteúdo da Lummefy pertencem à empresa e não podem ser copiados, modificados ou distribuídos sem autorização.</li>
            <li>O usuário mantém os direitos sobre seu conteúdo, mas concede licença de uso à Lummefy para operação dos serviços.</li>
        </ul>

        <h2>8. Alterações</h2>
        <ul>
            <li>A Lummefy poderá alterar estes Termos a qualquer momento, comunicando os usuários.</li>
        </ul>

        <h2>9. Foro</h2>
        <div class="legal-info">
            <ul>
                <li>Estes Termos são regidos pela legislação brasileira.</li>
                <li>O foro eleito é o da Comarca de Jundiaí/SP.</li>
            </ul>
        </div>

        <div class="warning">
            <p><strong>Importante:</strong> Ao utilizar a plataforma Lummefy, você concorda integralmente com estes Termos de Uso. Recomendamos a leitura atenta de todo o documento.</p>
        </div>

        <div class="last-updated">
            <p>Última atualização: Setembro de 2025</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TermsOfUse',
    data() {
        return {
            lastUpdate: 'Setembro de 2025'
        }
    }
}
</script>

<style scoped>
.content h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    color: #333;
}

.content p {
    margin-bottom: 1rem;
    line-height: 1.6;
}

.content ul {
    margin-bottom: 1rem;
    padding-left: 2rem;
}

.content li {
    margin-bottom: 0.5rem;
}
</style>
